import React from 'react'

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import QueryColumns from './Common/QueryColumns';
import Settings from './DataLoadTabs/Settings';

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = { 
    children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
});

class DataLoadEditor extends React.Component {

    state = {
        value: 0
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };

    render() {
        const { classes, query } = this.props;
        const { value } = this.state;
        return (
            <div className={classes.root}>
                <AppBar color="default" position="static">
                    <Tabs value={value} onChange={this.handleChange}>
                        <Tab label="Settings" />
                        <Tab label="Columns" />
                        {/* <Tab label="History" /> */}
                    </Tabs>
                </AppBar>
                {
                    value === 0 && 
                    <TabContainer>
                        <Settings query={query} {...this.props} />
                    </TabContainer>
                }
                {
                    value === 1 && 
                    <TabContainer>
                        <QueryColumns query={query} {...this.props} />
                    </TabContainer>
                }
            </div>
        )
    }
}

DataLoadEditor.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DataLoadEditor);


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/QueryEditors/DataLoadEditor.js